/* Loads Shopify's product recommendations into the "You may also like" box and
   drives its carousel. */
(function () {
  'use strict';
  if (window.TarRecommendations) return;
  window.TarRecommendations = true;

  function setupCarousel(box) {
    var track = box.querySelector('[data-related-track]');
    var prev = box.querySelector('[data-related-prev]');
    var next = box.querySelector('[data-related-next]');
    if (!track || !prev || !next) return;

    var items = [].slice.call(track.children);
    var index = 0;
    var max = 0;

    function render() {
      if (!items.length) return;
      var itemWidth = items[0].getBoundingClientRect().width;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var viewport = track.parentElement.getBoundingClientRect().width;
      var visible = Math.max(1, Math.round((viewport + gap) / (itemWidth + gap)));
      max = Math.max(0, items.length - visible);
      index = Math.min(index, max);
      track.style.transform = 'translateX(-' + (index * (itemWidth + gap)) + 'px)';
      prev.disabled = index <= 0;
      next.disabled = index >= max;
    }

    prev.addEventListener('click', function () { index = Math.max(0, index - 1); render(); });
    next.addEventListener('click', function () { index = Math.min(max, index + 1); render(); });
    window.addEventListener('resize', render);
    render();
  }

  // Shopify has no recommendations (common with few products): show other products instead.
  function useFallback(box) {
    var tpl = box.querySelector('template[data-fallback]');
    if (!tpl || !tpl.content.querySelector('.shop-item')) return;
    box.innerHTML = '';
    box.appendChild(tpl.content.cloneNode(true));
    box.classList.add('is-loaded');
    setupCarousel(box);
  }

  function load(box) {
    if (box.__tarLoading) return;
    var url = box.getAttribute('data-url');
    if (!url) return;
    box.__tarLoading = true;

    fetch(url).then(function (res) {
      if (!res.ok) throw new Error('recommendations ' + res.status);
      return res.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.querySelector('[data-related-track] .shop-item')) {
        box.innerHTML = fresh.innerHTML;
        box.classList.add('is-loaded');
        setupCarousel(box);
      } else {
        useFallback(box);
      }
    }).catch(function () { useFallback(box); });
  }

  function init() {
    [].slice.call(document.querySelectorAll('[data-recommendations]')).forEach(function (box) {
      if (box.classList.contains('is-loaded')) { setupCarousel(box); return; }
      load(box);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
